import React from "react";
import { cn } from "@/lib/utils";

const STATUS_STYLES = {
  new: "status-badge-new", pending: "status-badge-pending", preparing: "status-badge-preparing",
  ready: "status-badge-ready", delivered: "status-badge-ready", confirmed: "status-badge-ready",
  completed: "status-badge-completed", cancelled: "status-badge-cancelled",
};

const LABEL = {
  pending: "Pending",
  new: "New",
  preparing: "Preparing",
  ready: "Ready",
  delivered: "Delivered",
  confirmed: "Confirmed",
  completed: "Completed",
  cancelled: "Cancelled",
};

export default function StatusBadge({ status, className = "" }) {
  const style = STATUS_STYLES[status] || "status-badge-default";
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-[11px] font-medium border tracking-wide",
        style,
        className
      )}
      data-testid={`status-badge-${status}`}
    >
      <span className="h-1.5 w-1.5 rounded-full bg-current" />
      {LABEL[status] || status}
    </span>
  );
}
